<template>
  <div class="menu-box">
    <div class="Back_Home_page" @click="handelBack">
      <div class="Back_cen firm-clickable" >
        <div class="back_icon"></div>
        <p>返回首页</p>
      </div>
    </div>
    <div
      class="menu-box-item"
      v-for="(item, index) in menuList"
      :key="item.id"
      @click="routerChange(item, index)"
      :class="selIndex == item.id ? 'menu-box-item-yes' : 'menu-box-item-no'"
    >
      <div
        class="menu-text"
        :class="selIndex == item.id ? 'menu-sel-yes' : 'menu-sel-no'"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "set",
  props: {
    navNum: {},
  },
  data() {
    return {
      menuList: [
        {
          name: "我的商机",
          url: "/Opportunity/index",
          id: 1,
        },
      ],

      selIndex: 1,
    };
  },
  watch: {
    // 监听页面路径
    $route() {
      if (this.$route.path == "/Opportunity/index") {
        //
        this.selIndex = 1;
      }
    },
  },
  mounted() {
    // 获取当前页面路径
    let currentUrl = this.$route.path;
    // 判断路径，给selIndex赋值 用于高亮导航菜单当前选中
    if (currentUrl == "/Opportunity/index") {
      //
      this.selIndex = 1;
    }
  },
  methods: {
    // 返回首页
    handelBack() {
      this.$router.push({
        path: "/FirmHomePage",
      });
    },
    // 点击选择 导航菜单
    routerChange(val, index) {
      // 给this.selIndex 赋值选中项的id用于高亮选中
      this.selIndex = val.id;
      // 跳转选中页面
      this.$router.push(val.url);
    },
  },
};
</script>
<style lang="less" scoped>
.menu-box {
  display: flex;
  flex-direction: column;
  align-items: left;
  height: 100%;
  text-align: center;
  .Back_Home_page {
    width: 180px;
    height: 50px;
    background: rgba(97, 144, 232, 0.3);
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #409eff ;
    font-weight: 400;
    .Back_cen {
      width: 105px;
      height: 23px;
      line-height: 23px;
      cursor: pointer;
      margin: auto;
      display: flex;
      .back_icon {
        width: 19px;
        height: 23px;
        background-image: url("../../../../assets/imgs/back-da@3x.svg");
        background-size: 100% 100%;
      }
      p {
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }
  .menu-box-item {
    width: 100%;
    cursor: pointer;
    .menu-text {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 400;
      width: 180px;
      height: 40px;
      margin: auto;
    }
    .menu-sel-yes {
      color: #409eff ;
      font-size: 16px;
      font-weight: 400;
      line-height: 40px;
      background: #eeeeee;
      border-radius: 5px;
      margin-top: 10px;
    }
    .menu-sel-no {
      line-height: 40px;
      color: #1c1c1c;
      font-size: 16px;
      margin-top: 10px;
      // margin-left: 10px;
    }
    .menu-sel-no:hover {
      color: #409eff ;
    }
  }
}
</style>
